import ItemDetailAbilities from "./ItemDetailAbilities";

export default ItemDetailAbilities;
export { ItemDetailAbilities };
